export default async (state, presence = false) => ({ presence });
